export default __webpack_public_path__ + "static/media/empty.8b254a48.png";